/**
 * De filterknoppen boven de collegalijst op het bureauscherm (collega's-replica-spec §2.2), als
 * vraag aan de server.
 *
 * Eerst filterde het scherm de al geladen pagina: bij 51 collega's en een pagina van 25 vond
 * "Productie" alleen wie toevallig op die eerste pagina stond, en de voet zei "18 van 51"
 * (testrapport 28 okt., #17). `GET /colleagues` kent `department` en `shift` al en telt dan ook
 * het totaal op dezelfde filter, dus de lijst, "Meer laden" en de voet kloppen samen.
 *
 * Een knop is `null` (iedereen), `shift:<ploeg>` (Mijn ploeg) of de naam van een afdeling. Het
 * voorvoegsel houdt een afdeling die toevallig zo heet als een ploeg uit elkaar.
 */
export type ColleagueFilter = string | null;

export const SHIFT_PREFIX = 'shift:';

export function shiftFilter(shift: string): ColleagueFilter {
  return `${SHIFT_PREFIX}${shift}`;
}

export function colleagueFilterQuery(
  filter: ColleagueFilter,
): { department: string } | { shift: string } | Record<string, never> {
  if (filter === null) return {};
  if (filter.startsWith(SHIFT_PREFIX)) return { shift: filter.slice(SHIFT_PREFIX.length) };
  return { department: filter };
}
